export const STRINGS = {
  DEFAULT_MAP_RADIUS: 40233.5,
  DEFAULT_OON_MAP_RADIUS: 200,
  DEFAULT_MAX_DISTANCE: 25,
  DEFAULT_PAGINATION_LIMIT: 25,
  DEFAULT_LATITUDE: 33.869311,
  DEFAULT_LONGITUDE: -84.267871,
  DEFAULT_ZOOM: 9,
  NO_RESULT_FOUND: "No Results Found",
  ENTER_ADDRESS: "Please Enter Address",
  IN_NETWORK: "In Network",
  OUT_NETWORK: "Out of Network",
  RECEIVING_CLIENTS: "Receiving Client",
  NOT_RECEIVING_CLIENTS: "Not Receiving Clients",
  BUTTON_LABELS: {
    INCLUDE_OON: "Include Out of Network Providers",
    CREATE_NEW_PROVIDER: "Create New Provider",
    ADD_PROVIDER: "Add Provider to Case",
    HIDE_MAP: "Hide Map View",
    SHOW_MAP: "Show Map View",
  },
  DEFAULT_INIT_ADDRESS: {
    additionalDetails: {
      latitude: 33.7674998,
      longitude: -84.502606812,
    },
  },
};

export const NETWORK_OPTS = [
  { id: "IN_NETWORK_RECEIVING", value: 1, name: "In Network" },
  { id: "ALL", value: 0, name: "All" },
];
